import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import IngredientDetail from "@/pages/IngredientDetail";
import IngredientEdit from "@/pages/IngredientEdit";
import Formulations from "@/pages/Formulations";
import FormulationEdit from "@/pages/FormulationEdit";
import Login from "@/pages/Login";
import Users from "@/pages/Users";
import AppHeader from "@/components/AppHeader";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <div className="App bg-white">
      <AuthProvider>
        <BrowserRouter>
          <AppHeader />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/new" element={<ProtectedRoute requireRole="editor"><IngredientEdit mode="create" /></ProtectedRoute>} />
            <Route path="/ingredient/:id" element={<ProtectedRoute><IngredientDetail /></ProtectedRoute>} />
            <Route path="/ingredient/:id/edit" element={<ProtectedRoute requireRole="editor"><IngredientEdit mode="edit" /></ProtectedRoute>} />
            <Route path="/formulations" element={<ProtectedRoute><Formulations /></ProtectedRoute>} />
            <Route path="/formulations/new" element={<ProtectedRoute requireRole="editor"><FormulationEdit mode="create" /></ProtectedRoute>} />
            <Route path="/formulations/:id" element={<ProtectedRoute><FormulationEdit mode="edit" /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute requireRole="admin"><Users /></ProtectedRoute>} />
          </Routes>
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
